//封装接口
import { fetchSessionJson } from './fetch';
//获取布局中的视频流
export function getStreams(roomId, appServerUrl, sessionToken) {
  let paramsData = {
    type: "live2"
  };
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/layout/streams`,
      method: 'get',
      data: paramsData,
    }
  };
  return fetchSessionJson(params, appServerUrl, sessionToken);
}